import clsx from "clsx";
import React, { ReactNode } from "react";

import { Spacer } from "@/components/common/Spacer";

type Props = {
  title: string | ReactNode;
  children: ReactNode;
  error?: string;
  className?: string;
  hidden?: boolean;
};

export const FormItem = ({ title, children, error, hidden }: Props) => {
  return (
    <div className={clsx("flex flex-col", hidden ? "hidden" : "")}>
      <div className="flex items-center">
        <span className="txt-bold w-[86px] pr-[8px] text-right">{title}</span>
        <div className="flex items-center grow">{children}</div>
      </div>
      {error && (
        <div className="flex">
          <Spacer x="85px" />
          <div className="text-[#c00]">{error}</div>
        </div>
      )}
      <Spacer y="15px" />
    </div>
  );
};
